import { AuthActionCreators, IGet } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { useEffect, useState } from 'react';

export interface INetworkEmailLogSender {
    address: string;
    displayName: string;
}

const useNetworkEmailLogSenders = (centerId?: number): INetworkEmailLogSender[] => {
    const { dispatch } = useAppHookContext();
    const [senders, setSenders] = useState<INetworkEmailLogSender[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const params = new URLSearchParams();

            if (centerId) {
                params.append('centerId', String(centerId));
            }

            const config: IGet = { url: `${__API__}/email/network/log/senders?${params.toString()}` };

            try {
                const response = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.success) {
                    setSenders(response.data.results);
                }
            } catch {
                setSenders([]);
            }
        };

        fetchData();
    }, [centerId]);

    return senders;
};

export default useNetworkEmailLogSenders;
